// extracted by mini-css-extract-plugin
module.exports = {"AuxContainer":"AuxSticky_AuxContainer__2NThE"};